<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { Text } from '@Shelly/shelly-design-system';

	export let text: string;
	export let title = '';
	export let linkText = '';

	const dispatch = createEventDispatcher();

	const onLinkClick = (e: MouseEvent) => {
		e.preventDefault();
		dispatch('click', e);
	};
</script>

<div class="mb-m">
	{#if title}
		<Text styleType="body-medium" class="d-block mb-xs">{title}</Text>
	{/if}
	<Text styleType="body-small" class="text-color-muted">{text}</Text>
	{#if linkText}
		<Text href="#" styleType="body-small" class="d-block mt-s" on:click={onLinkClick}>
			{linkText}
		</Text>
	{/if}
</div>
